import {
  APP_MEASURE_SELECT_QUERY,
  CAMPAIGN_SELECT_QUERY_MAP,
  CustomEventKind,
  Events,
} from "model/reporterDb/dbTableCampaign";

export const METRIC_COLUMNS = [
  { id: "winrate", label: "Winrate" },
  { id: "ecpm", label: "eCPM" },
];
export const EVENT_COLUMNS = [
  { id: Events.bid, label: "Bids" },
  { id: Events.sales, label: "Sales" },
];

export const APP_MEASURES = [
  {
    id: "measureId",
    label: "Cat App Measure",
    value: "",
    kind: CustomEventKind.count,
    columnType: "AppMeasure",
  },
  {
    id: "CPAmeasureId",
    label: "Cat App Measure CPA",
    value: "",
    kind: CustomEventKind.count,
    columnType: "AppMeasureCPA",
  },
];

export const CAMPAIGN_ID = "CAMP_ID_1";
export const BASE_REPORT_CONFIG = {
  start: "2020-07-13T00:00:00.000Z",
  finish: "2020-07-13T23:59:59.999Z",
  groupBy: ["LINEITEM_ID", "DEVICE_OS"],
  filterBy: [],
  campaignId: CAMPAIGN_ID,
  granularity: "ALL",
  measuresCompoundObject: {
    eventColumns: EVENT_COLUMNS,
    metrics: METRIC_COLUMNS,
    appMeasures: [],
    cohortedMeasuresFlatList: [],
  },
};

export const BASE_SELECT_QUERY = [
  CAMPAIGN_SELECT_QUERY_MAP["bid"],
  CAMPAIGN_SELECT_QUERY_MAP["sales"],
  CAMPAIGN_SELECT_QUERY_MAP["winrate"],
  CAMPAIGN_SELECT_QUERY_MAP["ecpm"],
];

export const SELECT_APP_MEASURES_QUERY = [
  CAMPAIGN_SELECT_QUERY_MAP["bid"],
  CAMPAIGN_SELECT_QUERY_MAP["sales"],
  CAMPAIGN_SELECT_QUERY_MAP["winrate"],
  CAMPAIGN_SELECT_QUERY_MAP["ecpm"],
  APP_MEASURE_SELECT_QUERY.appMeasure({
    eventName: APP_MEASURES[0].id,
    kind: APP_MEASURES[0].kind,
  }),
  APP_MEASURE_SELECT_QUERY.appMeasureCPA(APP_MEASURES[1].id),
];
